import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/swiper.min.css";

// import Swiper core and required modules
import SwiperCore, {
  Pagination, Navigation
} from 'swiper/core';

// install Swiper modules
SwiperCore.use([Pagination, Navigation]);

interface GalleryItem {
  badge : string
  image: string
}

function Gallery({items}) {

  const { t } = useTranslation();

  function itemGallery(item : GalleryItem, index:  number) {
    return (
      <SwiperSlide key={index}>
        <div className="knsl-image-frame">
                <a data-fancybox="gallery" href={item.image}>
                    <img src={item.image} alt={t(`main.${item.badge}`) + `at The West Heaven Hotel`} className="swiper-lazy" />
                    <div className="knsl-badge">{t(`main.${item.badge}`)}</div>
                    <span className="knsl-zoom"><i className="fas fa-search-plus"></i></span>
                </a>
            </div>
      </SwiperSlide>
    )
  }

  return (
    <section className="knsl-transition-top knsl-p-0-100">
          <img src="assets/img/palm.svg" className="knsl-deco-left" alt="palm" />
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12">

                <div className="knsl-center knsl-title-frame knsl-scroll-animation knsl-mb-100">
                  <h2 className="knsl-mb-20">{t('main.waitingForYou')}</h2>
                  <p className="knsl-mb-30">{t('main.waitingForYouDesc')}</p>
                  <Link to="/about" className="knsl-btn knsl-btn-md">{t('main.moreAbout')}</Link>
                </div>

              </div>

            </div>
          </div>
          <div className="swiper-container knsl-about-slider knsl-scroll-animation">
            <Swiper 
              slidesPerView={1} 
              spaceBetween={20} 
              parallax={true} 
              updateOnWindowResize={true} initialSlide={1} 
              speed={800} 
              breakpoints={{1600 : {slidesPerView: 4}, 1200 : {slidesPerView: 3}, 760 : {slidesPerView: 2}} } 
              centeredSlides={true}
              pagination={{el: '.knsl-about-slider-1-pagination',type: "fraction",}}
              navigation={{prevEl: '.knsl-about-slider-1-prev',nextEl: '.knsl-about-slider-1-next'}}
            >
              {items.map((item: GalleryItem, index: number) => itemGallery(item,index))}

            {/* <!-- slider navigation --> */}
            <div className="container">
              <div className="knsl-slider-nav-panel">
                {/* <!-- pagination --> */}
                <div className="knsl-about-slider-1-pagination" style={{marginLeft: '30px'}}></div>
                {/* <!-- navigation --> */}
                <div className="knsl-about-slider-nav" style={{marginRight: '30px'}}>
                  <div className="knsl-about-slider-1-prev"><i className="fas fa-arrow-left" ></i></div>
                  <div className="knsl-about-slider-1-next"><i className="fas fa-arrow-right"></i></div>
                </div>
                {/* <!-- navigation end --> */}
              </div>
            </div>
            {/* <!-- slider navigation end --> */}
            </Swiper>
          </div>
    </section>
  )
}

export default Gallery